import { searchFormConstants } from "../constants";

export default function searchForm(state = {}, action: any) {
  switch (action.type) {
    case searchFormConstants.SET_PRICING:
      return {
        ...state,
        price: action.price,
      };

    default:
      return state;
  }
}
